<div *ngIf="product">
    <div [ngClass]="{'col-md-3': !wishListItem, 'col-md-3-2': wishListItem}" class="col-xs-12" *ngIf="isGridView">
        <div class="product">

            <a [routerLink]="['/products',product.skuCode]"
                [queryParams]="{subCategory: product.skuSubCategory, category: product.skuCategory}">
                <app-product-image [imageUrl]="product.imageUrl" [packSize]="product.packSize"
                    [capacity]="product.capacity" [discountPercentage]="product.discountPercentage"
                    [isNewProduct]="product.isNewProduct" [maxHeightImage]="true"></app-product-image>
            </a>
            <div class="product-body">
                <p class="product-category" [ngClass]="{'invisi-ink':product.skuCategory === ''}"><a
                        [routerLink]="['/products']" [queryParams]="{category: product.skuCategory}">{{
                        product.skuCategory === '' ? 'Unspecified' : product.skuCategory }}</a></p>
                <p class="product-brand" [ngClass]="{'invisi-ink':product.skuBrand === ''}"><a
                        [routerLink]="['/products']"
                        [queryParams]="{brand: product.skuBrand, category: product.skuCategory}">{{ product.skuBrand ===
                        '' ? 'Unspecified' : product.skuBrand }}</a></p>
                <h3 class="product-name"><a [routerLink]="['/products',product.skuCode]"
                        [queryParams]="{subCategory: product.skuSubCategory, category: product.skuCategory}">{{
                        product.skuDescription === '' ? 'No Description' : product.skuDescription }}</a></h3>
                <p> </p>
                <p><span class="product-sku"><a [routerLink]="['/products',product.skuCode]"
                            [queryParams]="{subCategory: product.skuSubCategory, category: product.skuCategory}">SKUCode
                            -{{
                            product.skuCode }}</a></span></p>


                <div *ngIf="!hasValidToken; else showPrice">
                    <a>
                        <button style="margin-bottom: 10px !important;" class="addtocart"
                            (click)="returnUrls(returnUrl)"> LOG IN TO VIEW PRICES
                        </button>
                    </a>
                </div>
                <div *ngIf="hasValidToken">
                    <div class="linegrey">

                    </div>
                    <div class="add-to-cart">
                        <div class="qty-label">
                            Qty
                            <div class="input-number">
                                <input type="number" min="1" [(ngModel)]="product.quantity" id="quantity"
                                    name="quantity" #quantity onkeypress="return event.charCode >= 48"
                                    oninput="value = value < 1 ? 1 : value">
                                <span class="qty-up" (click)="product.quantity = product.quantity + 1">+</span>
                                <span class="qty-down"
                                    (click)="product.quantity > 1 ? product.quantity = product.quantity - 1 : product.quantity">-</span>
                            </div>
                        </div>
                        <!-- <a [routerLink]="['/']"> -->
                        <button class="addtocart" (click)="addProductItemToCart(product, product.quantity)">ADD TO
                            CART</button>


                        <!-- </a> </div> -->
                        <div class="product-btns">
                            <button class="add-to-wishlist" (click)="removeFromWishList(product)"
                                *ngIf="productItem && onWishlist()"><i class="fa fa-heart" style="color: red"></i><span
                                    class="tooltipp">remove from
                                    wishlist</span></button>
                            <button class="add-to-wishlist" (click)="addItemToWishlist(product, product.quantity)"
                                *ngIf="productItem && !onWishlist()"><i class="fa fa-heart"
                                    style="color: silver"></i><span class="tooltipp">add to
                                    wishlist</span></button>
                            <button class="quick-view" data-backdrop="false" data-toggle="modal"
                                [attr.data-target]="'#myModal' + product.skuCode" *ngIf="!cartItem"><i
                                    class="fa fa-eye"></i><span class="tooltipp">quick
                                    view</span></button>
                            <button class="quick-close" (click)="removeFromWishList(product)" *ngIf="!productItem"><i
                                    class="fa fa-times"></i><span class="tooltipp">Remove</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- row -->
    <div class="containerlightgrey" *ngIf="!isGridView">

        <div class="row equal-height">
            <!-- Product main img -->
            <div class="col-md-2">
                <div class="product-wish ">
                    <a [routerLink]="['/products',product.skuCode]"
                        [queryParams]="{subCategory: product.skuSubCategory, category: product.skuCategory}">
                        <app-product-image [imageUrl]="product.imageUrl" [packSize]="product.packSize"
                            [capacity]="product.capacity" [discountPercentage]="product.discountPercentage"
                            [isNewProduct]="product.isNewProduct" [maxHeightImage]="true"></app-product-image>
                    </a>
                </div>
            </div>
            <div class="col-md-1">
            </div>
            <!-- Product details -->
            <div class="col-md-3">
                <div class="product-wishlist-details">
                    <h4 class="product-name">{{ product.skuDescription === '' ? 'No Description' :
                        product.skuDescription }}</h4>
                    <p> {{
                        product.skuCode }}</p>
                </div>
            </div>

            <div *ngIf="!hasValidToken">
                <div class="col-md-1">
                </div>
                <div class="col-md-5" style="margin-top: 50px;">
                    <a [routerLink]="['/login']">
                        <button class="addtocart"> LOG IN TO VIEW PRICES
                        </button>
                    </a>
                </div>

            </div>
            <div *ngIf="hasValidToken">
                <div class="col-md-3" *ngIf="!cartItem;else cartItemQty">
                    <div class="product-wishlist-details">
                        <div *ngIf="!hasValidToken; else showPrice"></div>
                        <div *ngIf="product.isNewProduct"><span class="product-available">New Product</span> </div>
                        <div><span class="product-available-code">{{ product.skuCode }}</span> </div>
                    </div>
                </div>
                <div class="col-md-3" *ngIf="!cartItem;else cartItemPrice">
                    <div class="product-wish">
                        <div class="product-body" *ngIf="hasValidToken">
                            <div class="add-to-cart">
                                <div class="qty-label">
                                    Qty
                                    <div class="input-number">
                                        <input type="number" min="1" [(ngModel)]="product.quantity" id="quantity"
                                            name="quantity" #quantity onkeypress="return event.charCode >= 48"
                                            oninput="value = value < 1 ? 1 : value">
                                        <span class="qty-up" (click)="product.quantity = product.quantity + 1">+</span>
                                        <span class="qty-down"
                                            (click)="product.quantity > 1 ? product.quantity = product.quantity - 1 : product.quantity">-</span>
                                    </div>
                                    <div style="width: 100%;
                                    margin-top: 10px; margin-left: 1%;
  margin-right: 1%;" *ngIf="!cartItem" class="addtocart" (click)="addProductItemToCart(product, product.quantity)"> ADD
                                        TO CART </div>
                                </div>


                            </div>
                            <div class="product-btns">
                                <button *ngIf="onWishlist()" class="wishlist-button"
                                    (click)="removeFromWishList(product)">
                                    <i class="fa fa-heart" style="color: red"></i><span class="tooltipp">remove from
                                        wishlist</span>
                                </button>
                                <button *ngIf="!onWishlist()" class="wishlist-button"
                                    (click)="addItemToWishlist(product, product.quantity)">
                                    <i class="fa fa-heart" style="color: silver"></i><span class="tooltipp">add to
                                        wishlist</span>
                                </button>
                                <button class="quick-view" data-backdrop="false" data-toggle="modal"
                                    [attr.data-target]="'#myModal' + product.skuCode" *ngIf="!cartItem"><i
                                        class="fa fa-eye"></i><span class="tooltipp">quick
                                        view</span></button>
                                <button class="quick-close" (click)="removeFromWishList(product)"
                                    *ngIf="!productItem"><i class="fa fa-times"></i><span
                                        class="tooltipp">Remove</span></button>
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>

            <!-- /Product details -->
        </div>
    </div>

    <div class="modal fade" [id]="'myModal' + product.skuCode" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Quick View</h5>
                    <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <!-- Product main img -->
                        <div class="col-md-5 product">
                            <a [routerLink]="['/products',product.skuCode]"
                                [queryParams]="{subCategory: product.skuSubCategory, category: product.skuCategory}">
                                <app-product-image [imageUrl]="product.imageUrl" [packSize]="product.packSize"
                                    [capacity]="product.capacity" [discountPercentage]="product.discountPercentage"
                                    [isNewProduct]="product.isNewProduct" [maxHeightImage]="true"></app-product-image>
                            </a>
                        </div>



                        <!-- Product details -->
                        <div class="col-md-7">
                            <div class="product-details">
                                <h2 class="product-name">{{ product.skuDescription === '' ? 'No Description' :
                                    product.skuDescription }}</h2>

                                <div *ngIf="!hasValidToken; else showPrice">
                                    <a [routerLink]="['/login']">
                                        <button> LOG IN TO VIEW PRICES
                                        </button>
                                    </a>
                                </div>
                                <div><span class="product-available-code">{{ product.skuCode }}</span>
                                </div>

                                <p><br>
                                    <!-- {{ product.skuDescription === '' ? 'No Description' : product.skuDescription }} -->
                                    <br>
                                    <br>
                                </p>


                                <div class="add-to-cart" *ngIf="hasValidToken">
                                    <div class="qty-label">
                                        Qty
                                        <div class="input-number">
                                            <input type="number" min="1" [(ngModel)]="product.quantity" id="quantity"
                                                name="quantity" #quantity onkeypress="return event.charCode >= 48"
                                                oninput="value = value < 1 ? 1 : value">
                                            <span class="qty-up"
                                                (click)="product.quantity = product.quantity + 1">+</span>
                                            <span class="qty-down"
                                                (click)="product.quantity > 1 ? product.quantity = product.quantity - 1 : product.quantity">-</span>
                                        </div>
                                    </div>
                                    <button class="addtocarttwo"
                                        (click)="addProductItemToCart(product, product.quantity)">ADD TO CART</button>
                                    <button *ngIf="onWishlist()" class="wishlist-button"
                                        (click)="removeFromWishList(product)">
                                        <i class="fa fa-heart" style="color: red"></i><span class="tooltipp">remove from
                                            wishlist</span>
                                    </button>
                                    <button *ngIf="!onWishlist()" class="wishlist-button"
                                        (click)="addItemToWishlist(product, product.quantity)">
                                        <i class="fa fa-heart" style="color: silver"></i><span class="tooltipp">add to
                                            wishlist</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- /Product details -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #cartItemQty>
    <div class="col-md-2" *ngIf="hasValidToken">
        <div class="product-wish">
            <div class="product-body">
                <div class="add-to-cart">
                    <div class="qty-label">Qty
                        <div class="input-number">
                            <input type="number" (change)="onQuantityUpdated($event, product)"
                                [(ngModel)]="product.quantity" id="quantity" name="quantity" #quantity
                                onkeypress="return event.charCode >= 48" oninput="value = value < 1 ? 1 : value">
                            <span class="qty-up" (click)="addProductItemToCart(product, 1)">+</span>
                            <span class="qty-down"
                                (click)="product.quantity > 1 ? removeFromCart(product, false) : product.quantity">-</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cartItemPrice>
    <div class="col-md-3">
        <div class="product-wishlist-details2">
            <div *ngIf="!hasValidToken; else showPrice">
                <button class="addtocart" disabled> LOG IN
                </button>
            </div>
            <div *ngIf="product.isNewProduct"><span class="product-available">New Product</span> </div>
            <div><span class="product-available-code">{{ product.skuCode }}</span> </div>
        </div>
    </div>
    <div class="col-md-1 col-xs-12" *ngIf="hasValidToken">
        <div class="product-cart">
            <div class="product-body">
                <div class="product-btns">
                    <button class="quick-close" (click)="removeFromCart(product, true)"><i class="fa fa-times"></i><span
                            class="tooltipp">Remove</span></button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #showPrice>
    <div *ngIf="hasValidToken">

        <div *ngIf="product.discountPriceExcl > 0">
            <div class="arrow-right" aria-hidden="true">
                <div class="arrow-text"
                    style="margin-left: -67px; margin-top: 10px; font-size: 10px; color: #efefef; transform: rotate(-45deg);">
                    Sale</div>
            </div>
            <h4 class="product-price">
                {{ product.discountPriceExcl * product.quantity | currency:'R' | amountFormat }} Excl
                <del class="product-old-price">{{ product.listPriceExcl * product.quantity | currency:'R' | amountFormat
                    }} </del>
            </h4>

            <h4 class="product-incl-price">{{ product.discountPriceIncl * product.quantity | currency:'R' | amountFormat
                }} Incl </h4>
            <div
                [ngClass]="{'product-available': product.stockOnHand !== 0, 'product-out-of-stock': product.stockOnHand === 0}">
                available in stock: ({{ product.stockOnHand }})
            </div>

        </div>
        <div *ngIf="product.discountPriceExcl === 0 || product.discountPriceExcl === null">
            <h4 class="product-price">{{ product.listPriceExcl * product.quantity | currency:'R' | amountFormat }} Excl
            </h4>
            <h4 class="product-incl-price">{{ product.listPriceIncl * product.quantity | currency:'R' | amountFormat }}
                Incl </h4>
            <div
                [ngClass]="{'product-available': product.stockOnHand !== 0, 'product-out-of-stock': product.stockOnHand === 0}">
                available in stock: ({{ product.stockOnHand }})
            </div>
        </div>
    </div>
</ng-template>
